import React from "react"
import styled from "styled-components"
import { FormNavigationContext } from "../../../Panes/Form"
import { postData } from "../../../../api"
import LoadingIndicator from "./LoadingIndicator"
import moment from "moment"
import _, { pick, isUndefined, get } from "lodash"

import FileUpload from "./Fileupload"

const LoadingSectionContainer = styled.div`
  text-align: center;
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.div`
  font-size: 30px;
`
const Subtitle = styled.div`
  font-size: 25px;
  margin-bottom: 50px;
`

export default class LoadingSection extends React.Component {
  state = {
    percentage: 0,
  }

  onChange = () => {
    this.props.onSubmit(this.props.question.identifier)
  }

  processCode(code) {
    if (this.context.activeIdentifier === this.props.question.identifier) {
      // eslint-disable-next-line
      this.codeResult = ((form, moment, _) => {
        // eslint-disable-next-line
        return eval("() => {" + code + "}")
      })(this.context.result, moment, _)()

      if (!this.props.durationInSeconds) {
        this.props.setFieldsValue({
          [this.props.question.identifier]: this.codeResult || this.props.value,
        })
        this.props.onSubmit(this.props.question.identifier)
      }
    }
  }

  requestDataFromUrl(url, paramsKeys, requestParamsConstants) {
    if (!url) return Promise.resolve()
    const data = pick(this.context.result, paramsKeys)
    return postData(
      `${url}${
        requestParamsConstants.length > 0 ? "?" : ""
      }${requestParamsConstants.join("&")}`,
      data
    ).then(result => {
      this.context.setFields(result)
    })
  }

  componentDidMount() {
    if (!isUndefined(this.props.uploadFiles) && !this.props.uploadFiles) {
      this.onUploadDone()
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onDone = () => {
    if (this.uploadDone && this.requestDone) {
      this.props.onSubmit(this.props.question.identifier)
    }
  }

  onUploadDone = () => {
    if (this.context.activeIdentifier !== this.props.question.identifier) return

    this.requestDataFromUrl(
      this.props.requestURL,
      this.props.requestParams,
      this.props.requestParamsConstants
    ).then(() => {
      this.processCode(get(this.props, ["calculationCode", "code"]))
      if (this.props.durationInSeconds) {
        this.elapsedSeconds = 1
        this.interval = setInterval(() => {
          this.elapsedSeconds += 1
          if (this.elapsedSeconds > this.props.durationInSeconds) {
            clearInterval(this.interval)
            this.props.setFieldsValue({
              [this.props.question.identifier]:
                this.codeResult || this.props.value,
            })
            this.props.onSubmit(this.props.question.identifier)
          }
          const percentage =
            (this.elapsedSeconds / this.props.durationInSeconds) * 100
          this.setState({
            percentage,
          })
        }, 1000)
      }
    })
  }

  render() {
    return (
      <LoadingSectionContainer>
        <Title>{this.props.headline}</Title>
        <Subtitle>{this.props.subheadline}</Subtitle>
        <LoadingIndicator percentage={this.state.percentage} />

        {this.props.getFieldDecorator &&
          this.props.getFieldDecorator(this.props.question.identifier, {
            initialValue: this.props.value,
          })(<span />)}
        {(isUndefined(this.props.uploadFiles) || this.props.uploadFiles) && (
          <FileUpload {...this.props} onFinish={this.onUploadDone} />
        )}
      </LoadingSectionContainer>
    )
  }
}

LoadingSection.defaultProps = {
  requestParamsConstants: [],
}

LoadingSection.contextType = FormNavigationContext
